var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9E3F7"
    },
    points: "272.696,239.305 272.696,161.391 239.304,161.391 239.304,239.305 77.913,239.305  77.913,350.609 111.304,350.609 111.304,272.697 400.696,272.697 400.696,350.609 434.087,350.609 434.087,239.305 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#78B9EB"
    },
    points: "272.696,239.305 272.696,161.391 256,161.391 256,272.697 400.696,272.697 400.696,350.609  434.087,350.609 434.087,239.305 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.435,
    y: 61.217,
    style: {
      fill: "#FFDA44"
    },
    width: 267.13,
    height: 111.304
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 61.217,
    style: {
      fill: "#FF9811"
    },
    width: 133.565,
    height: 111.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.783,
    y: 339.478,
    style: {
      fill: "#FF9811"
    },
    width: 189.217,
    height: 111.304
  })), /*#__PURE__*/React.createElement("rect", {
    x: 417.391,
    y: 339.478,
    style: {
      fill: "#FF5023"
    },
    width: 94.609,
    height: 111.304
  }), /*#__PURE__*/React.createElement("rect", {
    y: 339.478,
    style: {
      fill: "#FF9811"
    },
    width: 189.217,
    height: 111.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.609,
    y: 339.478,
    style: {
      fill: "#FF5023"
    },
    width: 94.609,
    height: 111.304
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.391d49322b7cb62929811cf6bfb135db.svg";
export { ForwardRef as ReactComponent };